import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodCashDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4292_542)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M42.3555 25C41.8276 25.6764 41.5215 26.4759 41.5215 27.333C41.5215 28.8642 42.4962 30.2119 43.9736 31H8.02637C9.50377 30.2119 10.4785 28.8642 10.4785 27.333C10.4785 26.4759 10.1724 25.6764 9.64453 25H42.3555ZM45 16.7627C45.5366 16.9318 46.1141 17.0359 46.7178 17.0605L47 17.0664V22.9336C46.2941 22.9336 45.6196 23.0411 45 23.2363V16.7627Z",
				fill: "#4ADE80",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.9268 25C31.5434 27.9884 28.9608 30 26 30C23.0392 30 20.4566 27.9884 19.0732 25H22.0352C22.6172 25.825 23.5753 26.3653 24.6611 26.3662H24.998V27C24.998 27.5523 25.4458 28 25.998 28C26.5503 28 26.998 27.5523 26.998 27V26.3652C28.1315 26.3604 29.1395 25.8272 29.791 25H32.9268Z",
				fill: "#4ADE80"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4C0 1.79086 1.79086 0 4 0H40C42.2091 0 44 1.79086 44 4V20C44 22.2091 42.2091 24 40 24H4C1.79086 24 0 22.2091 0 20V4Z",
				fill: "url(#paint0_linear_4292_542)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40 23.5V24H4V23.5H40ZM43.5 20V4C43.5 2.067 41.933 0.5 40 0.5H4C2.067 0.5 0.5 2.067 0.5 4V20C0.5 21.933 2.067 23.5 4 23.5V24L3.79395 23.9951C1.68056 23.8879 0 22.14 0 20V4C2.57702e-07 1.79086 1.79086 0 4 0H40C42.2091 0 44 1.79086 44 4V20C44 22.2091 42.2091 24 40 24V23.5C41.933 23.5 43.5 21.933 43.5 20Z",
				fill: "#4ADE80",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.8984 1C37.4795 1.74721 37.2412 2.60478 37.2412 3.5166C37.2412 6.4161 39.6502 8.7666 42.6211 8.7666C42.7485 8.76659 42.8748 8.76047 43 8.75195V15.7803C42.8748 15.7718 42.7485 15.7666 42.6211 15.7666C39.6502 15.7666 37.2412 18.1171 37.2412 21.0166C37.2412 21.7186 37.3835 22.388 37.6396 23H6.36035C6.61648 22.388 6.75879 21.7186 6.75879 21.0166C6.75879 18.1171 4.34982 15.7666 1.37891 15.7666C1.2515 15.7666 1.12519 15.7718 1 15.7803V8.75195C1.12521 8.76047 1.25148 8.76659 1.37891 8.7666C4.34982 8.7666 6.75879 6.4161 6.75879 3.5166C6.75879 2.60478 6.52051 1.74721 6.10156 1H37.8984Z",
				fill: "#4ADE80",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22 2C26.4183 2 30 6.47715 30 12C30 17.5228 26.4183 22 22 22C17.5817 22 14 17.5228 14 12C14 6.47715 17.5817 2 22 2ZM21.998 4C21.4458 4 20.998 4.44772 20.998 5V5.86621C19.0875 5.92972 17.5455 7.4489 17.4492 9.35156L17.4443 9.54102C17.4454 11.5303 19.0252 13.1482 20.998 13.2139V16.3662H20.6631C19.9913 16.3657 19.4465 15.8206 19.4463 15.1484C19.4463 14.5963 18.9984 14.1486 18.4463 14.1484C17.894 14.1484 17.4463 14.5962 17.4463 15.1484C17.4465 16.925 18.8858 18.3648 20.6611 18.3662H20.998V19C20.998 19.5523 21.4458 20 21.998 20C22.5503 20 22.998 19.5523 22.998 19V18.3652C24.9648 18.3568 26.5566 16.76 26.5566 14.791C26.5564 12.8227 24.9644 11.2262 22.998 11.2178V7.86328H23.3389C24.0112 7.86343 24.5555 8.40806 24.5557 9.0791V9.20801C24.5557 9.76023 25.0034 10.208 25.5557 10.208C26.1078 10.2079 26.5556 9.76017 26.5557 9.20801V9.0791C26.5555 7.30306 25.1153 5.86343 23.3389 5.86328H22.998V5C22.998 4.44774 22.5503 4.00003 21.998 4ZM22.998 13.2178C23.8598 13.2262 24.5564 13.9273 24.5566 14.791C24.5566 15.656 23.8597 16.3568 22.998 16.3652V13.2178ZM20.998 11.2109C20.1304 11.1472 19.4453 10.4257 19.4443 9.54102C19.4443 8.6565 20.129 7.93284 20.998 7.86914V11.2109Z",
				fill: "#4ADE80"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45 8.12598C46.7252 8.57002 48 10.1362 48 12V28C48 30.2091 46.2091 32 44 32H8C5.79086 32 4 30.2091 4 28V25H41C43.2091 25 45 23.2091 45 21V8.12598Z",
				fill: "url(#paint1_linear_4292_542)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45 8.12598C46.7252 8.57002 48 10.1362 48 12V28L47.9951 28.2061C47.8913 30.2512 46.2512 31.8913 44.2061 31.9951L44 32H8L7.79395 31.9951C5.7488 31.8913 4.10865 30.2512 4.00488 28.2061L4 28V25H4.5V28C4.5 29.933 6.067 31.5 8 31.5H44C45.933 31.5 47.5 29.933 47.5 28V12C47.5 10.4145 46.4457 9.07583 45 8.64551V8.12598Z",
				fill: "#4ADE80",
				fillOpacity: .16
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4292_542",
			x1: 0,
			y1: 0,
			x2: 38.1962,
			y2: 31.1228,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#4ADE80",
				stopOpacity: .02
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4ADE80",
				stopOpacity: .32
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_4292_542",
			x1: 4,
			y1: 8,
			x2: 42.1962,
			y2: 39.1228,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#4ADE80",
				stopOpacity: .02
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4ADE80",
				stopOpacity: .32
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4292_542",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 32,
				fill: "white"
			})
		})
	] })]
});
export default SvgPaymentMethodCashDark;
